<template>
    <div class="Experience">
        <div class="Experience__container"> 
            <video 
                id="video" 
                playsinline="" 
                :width="$width" 
                :height="$height"/>
            <ScenePixi ref="scenepixi"/>  
            <SceneMatter ref="scenematter"/> 
            <canvas ref="canvas" :width="$width" :height="$height" id="output"/>
            <Champagne ref="champagne" v-if="initialized && mode == 'champagne'"/>  
            <Petals ref="petals" v-if="initialized && mode == 'petals'"/>  
            <Ruban ref="ruban" v-if="initialized && mode == 'ruban'"/>    
            <Recorder ref="recorder" v-if="initialized"/>   
        </div>
    </div>
</template>

<script>

import { Application, Container, Graphics, Sprite } from 'pixi.js'
import Matter from 'matter-js'
import Champagne from '@/components/Champagne.vue'
import Petals from '@/components/Petals.vue'
import Ruban from '@/components/Ruban.vue'
import Recorder from '@/components/Recorder.vue'
import ScenePixi from '@/components/ScenePixi.vue'
import SceneMatter from '@/components/SceneMatter.vue'


export default {

    name: 'Experience',
    components: { Champagne, Petals, Ruban, Recorder, ScenePixi, SceneMatter },

    data: () => ({

        used: 'pixi',
        recording: false,
        initialized: false,
        mode: '',
        duration_capture: 5
    }),

    beforeDestroy() {

        if(this.$rafID){ cancelAnimationFrame(this.$rafID) }
    },

    created() {

        // const dt = localStorage.getItem('sessionData')
        // if(!dt) {
        //     const dataOBJ = { 'frame_id' : 2, 'frame_filename': 'frame_2.png' }
        //     localStorage.setItem( 'sessionData', JSON.stringify(dataOBJ) )
        // }
        // this.$sessionData = JSON.parse(dt)

        // if(this.$sessionData['frame_id'] === 1) this.mode = 'ruban'
        // else if(this.$sessionData['frame_id'] === 2) this.mode = 'champagne'
        // else this.mode = 'petals'

        this.mode = 'champagne'

        this.$coef = 1
        this.$debug = false
        this.$coef_video = 2
        this.$width = 1080*this.$coef
        this.$height = 1920*this.$coef
    },

    mounted() {

        this.$on_record = false

        this.bindPage()

        document.addEventListener('keypress', (event) => {

            if(event.keyCode === 32 && this.initialized) {
                this.$refs.scenematter.resetMatter()
                this.updateMode()
            }

            if(event.keyCode === 114 && this.initialized) {
                this.addRecord(10)
            }
        })

    },
    methods: {

        updateMode() {

            TweenMax.to(this.$black, 0.25, { alpha: 1, ease: Linear.easeNone }) 
            if(this.mode === 'champagne') this.mode = 'petals'
            else if(this.mode === 'petals') this.mode = 'ruban'
            else this.mode = 'champagne'
        },

        addRecord(_duration) {

            if(this.$on_record) return

            this.$on_record = true
            const duration = (_duration) ? _duration : this.duration_capture
            this.$refs.recorder.record()
            TweenMax.delayedCall(duration, ()=>{ 
                this.$on_record = false
                this.$refs.recorder.record() 

            })
        },

        resetRecord(_duration) {

            return

            const duration = (_duration) ? _duration : this.duration_capture
            this.$refs.recorder.record()
            TweenMax.delayedCall(duration, ()=>{ this.$refs.recorder.record() })
        },

        setupCamera: async function() {

            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                throw new Error(
                    'Browser API navigator.mediaDevices.getUserMedia not available')
            }

            this.$video = document.getElementById('video')
            this.$video.width = this.$width / this.$coef_video
            this.$video.height = this.$height / this.$coef_video

            const stream = await navigator.mediaDevices.getUserMedia({ 'audio': false, 'video': { facingMode: 'environment', width: this.$width / this.$coef_video, height: this.$height / this.$coef_video } })
            this.$video.srcObject = stream

            return new Promise((resolve) => {
                video.onloadedmetadata = () => {
                    resolve(this.$video)
                }
            })
        },

        loadVideo: async function() {

            const video = await this.setupCamera()
            video.play()
            return video
        },

        bindPage: async function () {

            this.$net = await posenet.load(0.75)
            try { this.$video = await this.loadVideo() } 
            catch (e) {}

            if(!this.$debug)
                this.$refs.scenepixi.addVideoToCanvas(this.$video)

            this.initialized = true
            this.detectPoseInRealTime()
        },

        detectPoseInRealTime: async function() {

            const imageScaleFactor = 0.5
            const outputStride = 16
            const flipHorizontal = true
            const maxPoseDetections = 2

            this.$poses = await this.$net.estimateMultiplePoses(this.$video, imageScaleFactor, flipHorizontal, outputStride, maxPoseDetections)   
            this.$refs.scenematter.updateMatter(this.$poses)
            this.$rafID = requestAnimationFrame(this.detectPoseInRealTime)
        },
    }
}
</script>

<style lang="stylus">

.Experience
    
    display block
    position absolute
    top 0
    left 0
    width 1080px
    height 1920px
    transform scaleX(-1)
    overflow hidden

    &__container
        background-color black
        width 100%
        height 100%
        //transform scale(2)     

a 
    font-size 40px
    transform scaleX(-1)

video
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    display none

#second_video
    border 1px solid red 
    left 20%
    display block

canvas 
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)  scaleX(-1)

#cv_matter
    left 20%


</style>













